import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { stylingHelpers } from '../../designTokens';

const { textMega } = stylingHelpers;

const baseStyles = ({ theme }) => css`
  ${textMega({ theme })};
  display: flex;
  align-items: flex-start;
  margin-top: ${theme.spacings.byte};
  color: ${theme.colors.n900};
  transition: color ${theme.transitions.default};
`;

const invalidStyles = ({ theme, invalid }) =>
  invalid &&
  css`
    color: ${theme.colors.danger};
  `;

const alignStyles = ({ textAlign }) =>
  textAlign === 'right' &&
  css`
    justify-content: flex-end;
  `;

const Container = styled('span')(baseStyles, invalidStyles, alignStyles);

const ValidationHint = ({ validationHint, ...props }) => {
  if (!validationHint) {
    return null;
  }

  return (
    <Container role='alert' id={props.id} invalid={props.invalid} textAlign={props.textAlign}>
      {validationHint}
    </Container>
  );
};

ValidationHint.propTypes = {
  validationHint: PropTypes.string,
  invalid: PropTypes.bool,
  textAlign: PropTypes.string,
  id: PropTypes.string,
};

export default ValidationHint;
